import { configureStore } from '@reduxjs/toolkit'
import { authApi } from './api/authApi'
import { profileApi } from './api/profileApi'
import { paymentApi } from './api/paymentApi'
import { loyaltyApi } from './api/loyaltyApi'
import { configApi } from './api/configApi'
import { originalApi } from './api/originalApi'
import { casinoApi } from './api/casinoApi'
import { p2pApi } from './api/p2pApi'
import { sportsbookApi } from './api/sportsbookApi'
import authReducer from './slices/authSlice'
import configReducer from './slices/configSlice'
import originalReducer from './slices/originalSlice'
import crashReducer from './slices/crashSlice'
import slideReducer from './slices/slideSlice'
import mineReducer from './slices/mineSlice'
import chickenReducer from './slices/chickenSlice'
import blackjackReducer from './slices/blackjackSlice'
import baccaratReducer from './slices/baccaratSlice'
import rouletteReducer from './slices/rouletteSlice'
import profileReducer from './slices/profileSlice'
import paymentReducer from './slices/paymentSlice'
import loyaltyReducer from './slices/loyaltySlice'
import casinoReducer from './slices/casinoSlice'
import p2pReducer from './slices/p2pSlice'
import sportsbookReducer from './slices/sportsbookSlice'

export const store = configureStore({
	reducer: {
		auth: authReducer,
		config: configReducer,
		original: originalReducer,
		crash: crashReducer,
		slide: slideReducer,
		mine: mineReducer,
		chicken: chickenReducer,
		blackjack: blackjackReducer,
		baccarat: baccaratReducer,
		roulette: rouletteReducer,
		profile: profileReducer,
		payment: paymentReducer,
		loyalty: loyaltyReducer,
		casino: casinoReducer,
		p2p: p2pReducer,
		sportsbook: sportsbookReducer,
		[authApi.reducerPath]: authApi.reducer,
		[profileApi.reducerPath]: profileApi.reducer,
		[paymentApi.reducerPath]: paymentApi.reducer,
		[loyaltyApi.reducerPath]: loyaltyApi.reducer,
		[configApi.reducerPath]: configApi.reducer,
		[originalApi.reducerPath]: originalApi.reducer,
		[casinoApi.reducerPath]: casinoApi.reducer,
		[p2pApi.reducerPath]: p2pApi.reducer,
		[sportsbookApi.reducerPath]: sportsbookApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(
			authApi.middleware,
			profileApi.middleware,
			paymentApi.middleware,
			loyaltyApi.middleware,
			configApi.middleware,
			originalApi.middleware,
			casinoApi.middleware,
			p2pApi.middleware,
			sportsbookApi.middleware,
		),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
